import script from "./AllProducts.vue?vue&type=script&setup=true&lang=js"
export * from "./AllProducts.vue?vue&type=script&setup=true&lang=js"

import "./AllProducts.vue?vue&type=style&index=0&id=7dc1cfb2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dc1cfb2"]])

export default __exports__